import React, { Fragment } from 'react';
import Box from 'components/elements/Box';
import AnimatedLoadingWrapper from 'components/base/AnimatedLoadingWrapper';
import ContentLoader from 'components/utility/ContentLoader/ContentLoader';
import times from 'lodash.times';
import styled from 'styled-components/macro';

const Loader = styled(ContentLoader)`
  width: 100%;
  max-width: 100%;
`;

const FAQLoader: React.FC = () => {
  const count = 6;

  return (
    <Box my={2}>
      <AnimatedLoadingWrapper loading={true}>
        <Loader
          width={1500}
          height={65 + (count - 1) * 50}
          uniquekey="FAQSkeleton"
        >
          {times(count, (idx) => (
            <Fragment key={`event-skeleton-${idx}`}>
              <rect width="1500" height="47" y={20 + 50 * idx} />
            </Fragment>
          ))}
        </Loader>
      </AnimatedLoadingWrapper>
    </Box>
  );
};

export default FAQLoader;
